<template>
    <div id="filterdate" class="filter-date">
        <FilterDatePreset :default-option="this.defaultOption"></FilterDatePreset>
        <FilterDateRange></FilterDateRange>
        <div class="filter-date-toggle">
          <a v-on:click="toggleDateFilter()">{{ dateToggleLabel }}</a>
        </div>
    </div>
</template>

<script>
import FilterDatePreset from '@/components/FilterDatePreset'
import FilterDateRange from '@/components/FilterDateRange'

export default {
  name: 'filterDate',

  props: {
    'defaultOption': {
      type: Object,
      required: false
    }
  },

  data: function () {
    return {
      dateToggleLabel: 'Custom date range'
    }
  },

  components: {
    'FilterDatePreset': FilterDatePreset,
    'FilterDateRange': FilterDateRange
  },

  methods: {
    toggleDateFilter () {
      let wellContent = document.getElementById('filterdate')
      wellContent.classList.toggle('s-date-toggled')

      if ((this.dateToggleLabel) === 'Preset date range') {
        this.dateToggleLabel = 'Custom date range'
      } else {
        this.dateToggleLabel = 'Preset date range'
      }
    }
  }
}

</script>

<style lang="scss">
@import "./src/sass/components/FilterDate.scss";
</style>



// WEBPACK FOOTER //
// FilterDate.vue?d489213c